import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "TableBox" }
const _hoisted_2 = { class: "TableTop" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("筛选")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_5 = { class: "TableTopBtn" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("新增")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 编辑 ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("删除")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_AddOrEditDialog = _resolveComponent("AddOrEditDialog")!
  const _component_PageMain = _resolveComponent("PageMain")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_PageMain, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_form, {
            model: _ctx.query,
            inline: "",
            onSubmit: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"]))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { label: "岗位名称：" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.query.name,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.query.name) = $event)),
                    placeholder: "请输入岗位名称",
                    size: "small",
                    clearable: "",
                    onClear: _cache[1] || (_cache[1] = ($event: any) => (_ctx.getList('place')))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    size: "small",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.getList('place')))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_3
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_button, {
                    size: "small",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.init()))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_4
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"]),
          _createElementVNode("div", _hoisted_5, [
            (_ctx.$globalFun.ifAuth(_ctx.$route, '新增'))
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  type: "primary",
                  size: "small",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onAddOrEdit()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ])
        ]),
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          ref: "tableListRef",
          class: "TableList",
          border: "",
          data: _ctx.list,
          height: "100%"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "name",
              label: "岗位名称",
              align: "center"
            }),
            _createVNode(_component_el_table_column, {
              prop: "created_at",
              label: "创建时间",
              align: "center"
            }),
            _createVNode(_component_el_table_column, {
              label: "操作",
              align: "center",
              width: "240",
              fixed: "right"
            }, {
              default: _withCtx((scope) => [
                (_ctx.$globalFun.ifAuth(_ctx.$route, '编辑'))
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 0,
                      type: "primary",
                      size: "mini",
                      onClick: ($event: any) => (_ctx.onAddOrEdit(scope.row.id))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_7
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true),
                (_ctx.$globalFun.ifAuth(_ctx.$route, '删除'))
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 1,
                      type: "danger",
                      size: "mini",
                      onClick: ($event: any) => (_ctx.onDel(scope.row.id))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_8
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])), [
          [_directive_loading, _ctx.loading]
        ]),
        _createVNode(_component_el_pagination, {
          class: "TablePagination",
          background: "",
          onSizeChange: _ctx.handleSizeChange,
          onCurrentChange: _ctx.handleCurrentChange,
          "current-page": _ctx.query.page,
          "page-sizes": [20, 40, 60, 100],
          "page-size": _ctx.query.paginate,
          layout: "total, sizes, prev, pager, next, jumper",
          total: _ctx.total
        }, null, 8, ["onSizeChange", "onCurrentChange", "current-page", "page-size", "total"])
      ]),
      _createVNode(_component_AddOrEditDialog, { ref: "addOrEditDialogRef" }, null, 512)
    ]),
    _: 1
  }))
}